import React from "react";
import { Route, Switch } from "react-router-dom";
import { Path } from "enums";
import BankDepositModule from "modules/cash-tracking/bank-deposit/bank-deposit.module";
import BankDepositDetailsModule from "modules/cash-tracking/bank-deposit/bank-deposit-details/bank-deposit-details.module";
import { Redirect } from "react-router-dom/cjs/react-router-dom.min";
import ExpenseModule from "modules/cash-tracking/expense/expense.module";
import ExpenseDetailsModule from "modules/cash-tracking/expense/expense-details/expense-details.module";
import KeyAccountModule from "modules/cash-tracking/key-accounts/key-account.module";
import KeyAccountDetailsModule from "modules/cash-tracking/key-accounts/key-account-details/key-account-details.module";

const CashTrackingPage = () => {
  return (
    <Switch>
      <Route exact path={Path.BankDeposit} component={BankDepositModule} />
      <Route exact path={Path.AddBankDeposit} component={BankDepositDetailsModule} />
      <Route exact path={Path.BankDepositDetails} component={BankDepositDetailsModule} />

      <Route exact path={Path.Expense} component={ExpenseModule} />
      <Route exact path={Path.AddExpense} component={ExpenseDetailsModule} />
      <Route exact path={Path.ExpenseDetails} component={ExpenseDetailsModule} />

      <Route exact path={Path.KeyAccount} component={KeyAccountModule} />
      <Route exact path={Path.AddKeyAccount} component={KeyAccountDetailsModule} />
      <Route exact path={Path.KeyAccountDetails} component={KeyAccountDetailsModule} />

      <Redirect to={Path.BankDeposit} />
    </Switch>
  );
};

export default CashTrackingPage;
